import axios from 'axios';
let httpInstance = axios;
// Allow main.js to set the configured axios instance
export function setHttpInstance(instance) {
    httpInstance = instance;
}
export function getHttpInstance() {
    return httpInstance;
}
let apiConfig = {
    api: '',
    configUri: '',
    useCachedEndpoints: true,
    useCache: true,
    cachedBlacklist: ["/VerifiedEmails/", "/logo", "/Documents/", "/Achievements/Points", "/Achievements", "/Quizzes", "/Chats/Messages", "/CMS", "/Payments"],
    cookies: null,
    router: null,
};
export function setApiConfig(config) {
    apiConfig = { ...apiConfig, ...config };
}
function cacheSettingEnabled(key) {
    if (localStorage.getItem('showHiddenSettings') !== 'true')
        return true;
    return localStorage.getItem(key) !== 'false';
}
export function getApiConfig() {
    return {
        ...apiConfig,
        useCachedEndpoints: cacheSettingEnabled('useCachedEndpoints'),
    };
}
export function useApi() {
    function getFromCache(url) {
        if (!cacheSettingEnabled('useLocalCache'))
            return null;
        const raw = localStorage.getItem(url);
        if (!raw)
            return null;
        try {
            const cache = JSON.parse(raw);
            if (cache.expires > Date.now()) {
                return cache.data;
            }
        }
        catch {
            // ignore parse errors
        }
        return null;
    }
    function cache(url, data, ttlMins = 3) {
        if (!cacheSettingEnabled('useLocalCache'))
            return;
        try {
            localStorage.setItem(url, JSON.stringify({
                data: data,
                expires: new Date().setMinutes(new Date().getMinutes() + ttlMins)
            }));
        }
        catch (e) {
            console.log(e, 'Caching error');
            localStorage.clear();
        }
    }
    function cacheUrl(path) {
        const useCachedEndpoints = cacheSettingEnabled('useCachedEndpoints');
        const useCachedPrefix = useCachedEndpoints && !apiConfig.cachedBlacklist.some(endpoint => path.includes(endpoint));
        return apiConfig.api + (useCachedPrefix ? '/Cached' : '') + path;
    }
    function clearExpiredCaches() {
        for (let i = localStorage.length - 1; i >= 0; i--) {
            const key = localStorage.key(i);
            if (key && key.startsWith(apiConfig.api)) {
                try {
                    const entry = JSON.parse(localStorage.getItem(key));
                    if (entry && entry.expires !== undefined && entry.expires < Date.now()) {
                        localStorage.removeItem(key);
                    }
                }
                catch {
                    // ignore
                }
            }
        }
    }
    function GET(url, onSuccess, useCache = false, forceSetCache = false, ttlMins = 3, retrying = false, staleWhileRevalidate = false) {
        url = url.replace(/\/+$/, '');
        const useCachedEndpoints = cacheSettingEnabled('useCachedEndpoints');
        if (useCachedEndpoints && !url.toLowerCase().includes('/cached/')) {
            if (!apiConfig.cachedBlacklist.some(endpoint => url.includes(endpoint))) {
                if (apiConfig.api && url.startsWith(apiConfig.api)) {
                    url = apiConfig.api + "/Cached" + url.slice(apiConfig.api.length);
                }
                else {
                    url = "/Cached" + url;
                }
            }
        }
        if (!url.includes(apiConfig.api)) {
            url = apiConfig.api + url;
        }
        if (useCache) {
            const fromCache = getFromCache(url);
            let attempts = 0;
            if (fromCache) {
                if (fromCache === 'loading') {
                    const interval = setInterval(() => {
                        const updatedCache = getFromCache(url);
                        if (updatedCache && updatedCache !== 'loading') {
                            clearInterval(interval);
                            if (onSuccess)
                                onSuccess(updatedCache);
                        }
                        attempts++;
                        if (attempts > 14) {
                            clearInterval(interval);
                            localStorage.removeItem(url);
                            GET(url, onSuccess, useCache, forceSetCache);
                        }
                    }, 500);
                    return;
                }
                if (onSuccess)
                    onSuccess(fromCache);
                return;
            }
        }
        if (staleWhileRevalidate) {
            const raw = localStorage.getItem(url);
            if (raw) {
                try {
                    const staleData = JSON.parse(raw).data;
                    if (staleData && staleData !== 'loading') {
                        if (onSuccess)
                            onSuccess(staleData);
                    }
                }
                catch { /* ignore */ }
            }
        }
        const previousCache = getFromCache(url);
        if (forceSetCache) {
            cache(url, 'loading', ttlMins);
        }
        httpInstance.get(url)
            .then((result) => {
            if (useCache || forceSetCache || staleWhileRevalidate) {
                cache(url, result.data, ttlMins);
            }
            if (onSuccess)
                onSuccess(result.data);
        })
            .catch((result) => {
            if (result.response && result.response.status == 401 && !retrying) {
                refreshLogin(() => {
                    GET(url, onSuccess, useCache, forceSetCache, ttlMins, true, staleWhileRevalidate);
                });
            }
            else if (result.response && result.response.status == 401 && retrying) {
                console.error('Retrying GET request failed due to unauthorized access:', url);
                if (forceSetCache)
                    localStorage.removeItem(url);
            }
            else if (staleWhileRevalidate) {
                // Silently swallow — user keeps seeing stale/cached data
            }
            else if (previousCache && previousCache !== 'loading') {
                cache(url, previousCache, ttlMins);
                if (onSuccess)
                    onSuccess(previousCache);
            }
            else if (forceSetCache) {
                localStorage.removeItem(url);
            }
        });
    }
    function login(email, password, onSuccess = null) {
        httpInstance.post(apiConfig.api + "/Sessions", {
            "userName": email,
            "password": password
        })
            .then((result) => {
            try {
                const token = result.data.session.token;
                apiConfig.cookies.set('token', token, '30min');
                httpInstance.defaults.headers.common = { "Authorization": "bearer " + token };
                if (onSuccess)
                    onSuccess(true);
            }
            catch {
                if (onSuccess)
                    onSuccess(false);
            }
        });
    }
    function refreshLogin(onSuccess = null) {
        if (!apiConfig.cookies.get('user') || !apiConfig.cookies.get('pass')) {
            window.location.href = "/MG_POP.html";
            return;
        }
        const email = apiConfig.cookies.get('user');
        const password = apiConfig.cookies.get('pass');
        login(email, password, onSuccess);
    }
    function openV1(path, returnPath = null) {
        if (!returnPath)
            returnPath = '#';
        window.location.href = "/MG_NAV_" + path + "_";
        setTimeout(() => {
            window.location.href = window.location.origin + '/#/' + returnPath;
        }, 500);
    }
    function signalV1(op, val, val2, val3, returnPath = null) {
        if (!returnPath)
            returnPath = '#';
        window.location.href = "/MG_SIG_" + op + "_" + val + "_" + val2 + "_" + val3 + "_";
        setTimeout(() => {
            window.location.href = window.location.origin + '/#/' + returnPath;
        }, 500);
    }
    return {
        GET,
        getFromCache,
        cache,
        cacheUrl,
        clearExpiredCaches,
        login,
        refreshLogin,
        openV1,
        signalV1,
    };
}
